<script lang="ts" setup>
	export type ButtonTabStyle<T = string> = {
		value: string | number
		label?: string
		key: T
		activeClass?: ClassContext
		class?: ClassContext
		active?: boolean
		disabled?: boolean
		icon?: {
			name: string
			dir: string
			pathClass?: string
			circleClass?: string
			activeState?: {
				circle?: string
				path?: string
			}
		}
	}

	const props = defineProps<{
		list: Record<string, ButtonTabStyle>
	}>()
	const emits = defineEmits<{
		(event: 'change', param: string): void
	}>()
	const selectTab = (arg: ButtonTabStyle) => {
		Object.values(props.list).forEach(i => (i.active = false))
		arg.active = true
		emits('change', arg.key)
	}
</script>

<template>
	<ul class="flex flex-wrap items-center gap-x-3 gap-y-3">
		<template v-for="(item, iKey) in list" :key="iKey">
			<li v-if="!item.disabled">
				<slot :name="item.key">
					<button
						type="button"
						class="inline-flex items-center gap-x-2 rounded-3xl border px-2 py-1 text-xs sm:px-4 sm:py-2"
						:class="[
							item.class,
							{ 'font-medium': item.active, 'text-gray-700': !item.active },
							(item.active && item.activeClass) || ''
						]"
						:aria-label="item.value as string"
						:data-testid="item.key"
						@click="selectTab(item)"
					>
						<lazy-tools-icon
							v-if="item?.icon"
							:icon="item.icon.name"
							:dir="item.icon.dir"
							:height="20"
							:width="20"
							:path-class="`${
								item.active ? item.icon.activeState?.path : item.icon.pathClass
							} opacity-100`"
							:circle-class="` ${
								item.active ? item.icon.activeState?.circle : item.icon.circleClass
							} stroke-transparent`"
						/>
						{{ item?.label || iKey }} <span v-show="item.value !== ''">({{ item.value }})</span>
					</button>
				</slot>
			</li>
		</template>
	</ul>
</template>
